import { AppState } from '~src/bootstrap/redux/state/AppState';

import { IResourceActionsState } from '../types/ResourceActionTypes';

export function getResourceActionsState(state: AppState): IResourceActionsState {
  return state.resourceActions;
}

export function getActionsByResourceType(
  state: AppState
): Map<string, Set<string>> {
  return getResourceActionsState(state).actionsByResourceType;
}

export function isFetchingResourceActions(state: AppState): boolean {
  return getResourceActionsState(state).isFetching;
}

export function getResourceActionsFetchError(state: AppState): string | undefined {
  return getResourceActionsState(state).fetchError;
}

/**
 * Check if user can perform a specific action on a resource type
 * @param resourceType - e.g., 'User', 'Group'
 * @param action - e.g., 'SEE_SITE_USERS', 'MODIFY_USERS'
 */
export function canPerformAction(
  state: AppState,
  resourceType: string,
  action: string
): boolean {
  const actionsByType = getActionsByResourceType(state);
  const actionsForResource = actionsByType.get(resourceType);
  return actionsForResource?.has(action) ?? false;
}

/**
 * Check if user can perform ANY of the provided actions
 */
export function canPerformAnyAction(
  state: AppState,
  resourceType: string,
  actions: string[]
): boolean {
  return actions.some(action => canPerformAction(state, resourceType, action));
}

/**
 * Check if user can perform ALL of the provided actions
 */
export function canPerformAllActions(
  state: AppState,
  resourceType: string,
  actions: string[]
): boolean {
  return actions.every(action => canPerformAction(state, resourceType, action));
}

/**
 * Get all actions for a resource type
 */
export function getActionsForResourceType(
  state: AppState,
  resourceType: string
): Set<string> {
  const actionsByType = getActionsByResourceType(state);
  return actionsByType.get(resourceType) ?? new Set();
}
